import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Paus from "./pages/Paus";
import Ilo from "./pages/Ilo";
import PausTerms from "./pages/PausTerms";
import PausPrivacy from "./pages/PausPrivacy";

export default function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/paus" element={<Paus />} />
        <Route path="/ilo" element={<Ilo />} />

        {/* PAUS legal pages */}
        <Route path="/paus/terms-of-use" element={<PausTerms />} />
        <Route path="/paus/privacy-policy" element={<PausPrivacy />} />

        {/* The Home footer already links to these two URLs, so send them to the PAUS pages */}
        <Route path="/terms-and-conditions" element={<Navigate to="/paus/terms-of-use" replace />} />
        <Route path="/privacy-policy" element={<Navigate to="/paus/privacy-policy" replace />} />
      </Routes>
    </Router>
  );
}